/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface SelfDestructEthPayer extends Contract<SelfDestructEthPayer> {
  destructTo: Send<(_recipient: AddressLike) => void, SelfDestructEthPayer>
  'destructTo(address)': Send<(_recipient: AddressLike) => void, SelfDestructEthPayer>
}

let SelfDestructEthPayerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  SelfDestructEthPayerBytecode = '0x6080604052348015600f57600080fd5b5060888061001e6000396000f3fe608060405260043610601c5760003560e01c806337a55f77146021575b600080fd5b604460048036036020811015603557600080fd5b50356001600160a01b03166046565b005b806001600160a01b0316fffea26469706673582212205b359d2c9dc3fb09a80ed13b853d1649ff24baedd05f789baeccd34134613fcc64736f6c634300060c0033';
}

// prettier-ignore
export const SelfDestructEthPayer = contract<SelfDestructEthPayer>(SelfDestructEthPayerBytecode)`
  function destructTo(address _recipient) payable
`;